import { useTranslation } from "react-i18next";
import { SearchboxV2 } from "#src/commonV2/Table/Searchbox";
import {
  FilterDropdownV2,
  IFilterDropdownProps,
} from "#src/commonV2/Table/Filter/FilterDropdown";

type Props = {
  searchKeyword: string;
  setSearchKeyword: (keyword: string) => void;
  setSelectedPage: (page: number) => void;
  vulnerableFilterRenderProps: IFilterDropdownProps;
  typeFilterRenderProps: IFilterDropdownProps;
};

export const SoftwareFilter = (props: Props) => {
  const {
    searchKeyword,
    setSearchKeyword,
    setSelectedPage,
    vulnerableFilterRenderProps,
    typeFilterRenderProps,
  } = props;
  const { t } = useTranslation("endpoint", { keyPrefix: "devices" });

  // ----------------------------- PARAMS -----------------------------

  // ----------------------------- COMPUTED -----------------------------

  // ----------------------------- HOOKS -----------------------------

  // ----------------------------- EFFECTS -----------------------------

  // ----------------------------- RENDER -----------------------------

  return (
    <div className="flex flex-col sm:flex-row justify-between gap-2">
      <div className="flex gap-2">
        <FilterDropdownV2 {...typeFilterRenderProps} />
        <FilterDropdownV2 {...vulnerableFilterRenderProps} />
      </div>

      <SearchboxV2
        value={searchKeyword}
        onChange={(value) => {
          setSearchKeyword(value);
          setSelectedPage(1);
        }}
        placeholder={t("common.search")}
      />
    </div>
  );
};
